<ng-container *ngFor="let column of rowDisplayColumns">
  <ng-container *ngIf="tableService.getHeaderCell(column) as headerCell">
    <ng-container *ngTemplateOutlet="headerCell.templateRef"></ng-container>
  </ng-container>
</ng-container>
